// NOTE: This Obj should be merged with PageProductSeries when we turn off Ruby app
import * as Scrivito from "scrivito";
import { createMultiselectComponent } from "utils";
import categoriesProducts from "config/locals/keysCategoriesProducts.json";
import {
  defaultPageEditingConfigAttributes,
  defaultPropertiesGroups,
  defaultPageInitialContent,
  defaultPageProperties,
  defaultPageValidations,
} from "objs/_defaultPageEditingConfig";
import {
  metadataEditingConfigAttributes,
  metadataInitialContent,
  metadataPropertiesGroups,
  metadataValidations,
} from "objs/_metadataEditingConfig";

Scrivito.provideEditingConfig("ProductSeries", {
  title: "Product series",
  attributes: {
    ...defaultPageEditingConfigAttributes,
    ...metadataEditingConfigAttributes,
  },
  properties: [
    ...defaultPageProperties,
    "uuid",
    "epfId",
    "erpNumber",
    "erpNumbers",
    "linkedSpareParts",
    "documents",
  ],
  propertiesGroups: [
    {
      title: "General settings",
      properties: [
        "introductionComplementaryText",
        "introductionImage",
        "introductionText",
        "introductionTitle",
      ],
    },
    {
      title: "Categories",
      component: createMultiselectComponent([
        {
          title: "Category series",
          attribute: "categorySeries",
          values: categoriesProducts.series,
        },
        {
          title: "Category groups",
          attribute: "categoryGroups",
          values: categoriesProducts.groups,
        },
        {
          title: "Category subsegments",
          attribute: "categorySubsegments",
          values: categoriesProducts.subsegments,
        },
        {
          title: "Category segments",
          attribute: "categorySegments",
          values: categoriesProducts.segments,
        },
      ]),
    },
    {
      title: "Introduction",
      properties: [
        "largeTabBoxTitle",
        "navigationTitle",
        "searchTitle",
        "body",
        "complementaryText",
        "header",
        "image",
        "ogDescription",
        "promoHeader",
        "promoText",
      ],
    },
    {
      title: "A-Z list",
      properties: ["azListDisabled", "azListTitle"],
    },
    {
      title: "Product finder filter",
      properties: [
        "filterApplication",
        "filterCharacteristics",
        "filterDesign",
        "filterMaterial",
        "filterSlideDepth",
        "filterSlideFlow",
        "filterSlideHeight",
        "filterSlideSoundPressure",
        "filterSlideWidth",
        "filterJson",
      ],
    },
    {
      title: "Product characteristics",
      properties: [
        "productInfoComment",
        "productInfoDimensions",
        "productInfoFlow",
        "productInfoFormat",
        "productInfoMaterial",
        "productInfoText1",
        "productInfoText2",
      ],
    },
    {
      title: "Tabs & Boxes settings", // we could consider to create a separate Scrvitio Extension Component
      properties: [
        "extendedMultitabBox1HiddenMobile",
        "extendedMultitabBox1Tab1Image",
        "extendedMultitabBox1Tab1Text",
        "extendedMultitabBox1Tab1Title",
        "extendedMultitabBox1Tab2Image",
        "extendedMultitabBox1Tab2Text",
        "extendedMultitabBox1Tab2Title",
        "extendedMultitabBox1Tab3Image",
        "extendedMultitabBox1Tab3Text",
        "extendedMultitabBox1Tab3Title",
        "extendedMultitabBox1Tab4Image",
        "extendedMultitabBox1Tab4Text",
        "extendedMultitabBox1Tab4Title",
        "extendedMultitabBox1Tab5Image",
        "extendedMultitabBox1Tab5Text",
        "extendedMultitabBox1Tab5Title",
        "extendedMultitabBox1Tab6Image",
        "extendedMultitabBox1Tab6Text",
        "extendedMultitabBox1Tab6Title",
        "extendedMultitabBox0Title",
        "extendedMultitabBox1Title",
        "extendedMultitabBox2HiddenMobile",
        "extendedMultitabBox2Tab1Image",
        "extendedMultitabBox2Tab1Text",
        "extendedMultitabBox2Tab1Title",
        "extendedMultitabBox2Tab2Image",
        "extendedMultitabBox2Tab2Text",
        "extendedMultitabBox2Tab2Title",
        "extendedMultitabBox2Tab3Image",
        "extendedMultitabBox2Tab3Text",
        "extendedMultitabBox2Tab3Title",
        "extendedMultitabBox2Tab4Image",
        "extendedMultitabBox2Tab4Text",
        "extendedMultitabBox2Tab4Title",
        "extendedMultitabBox2Tab5Image",
        "extendedMultitabBox2Tab5Text",
        "extendedMultitabBox2Tab5Title",
        "extendedMultitabBox2Tab6Image",
        "extendedMultitabBox2Tab6Text",
        "extendedMultitabBox2Tab6Title",
        "extendedMultitabBox2Title",

        "largeTab1Image",
        "largeTab1Text",
        "largeTab1Title",
        "largeTab2Image",
        "largeTab2Text",
        "largeTab2Title",
        "largeTab3Image",
        "largeTab3Text",
        "largeTab3Title",
        "largeTab4Image",
        "largeTab4Text",
        "largeTab4Title",
        "largeTab5Image",
        "largeTab5Text",
        "largeTab5Title",
        "largeTab6Image",
        "largeTab6Text",
        "largeTab6Title",
        "largeTabBoxTitle",
        "smallTab1Text",
        "smallTab1Title",
        "smallTab2Text",
        "smallTab2Title",
        "smallTab3Text",
        "smallTab3Title",
      ],
    },
    ...defaultPropertiesGroups,
    ...metadataPropertiesGroups,
  ],
  initialContent: {
    ...defaultPageInitialContent,
    ...metadataInitialContent,
  },
  validations: [...defaultPageValidations, ...metadataValidations],
});
